<script setup lang="ts">
import Error from "./Error.vue";

interface Props {
    errors?: Array<string>|null,

}
const props = withDefaults(defineProps<Props>(), {
    errors: []
});
</script>

<template>
    <div>
        <Error v-for="error in errors" key="" :error="error" />
    </div>
</template>
